import React from 'react'
import QRCode from 'react-qr-code'

const QRCodeComponent = ({ roomCode, size = 80, className = '', fgColor = "#ffffff", bgColor = "transparent" }) => {
  if (!roomCode) return null

  return (
    <div className={`flex flex-col items-center p-3 rounded-lg transition-all duration-300 hover:scale-[3] origin-top-right opacity-80 hover:opacity-100 mix-blend-difference ${className}`}>
      <QRCode
        value={`${window.location.origin}/room/${roomCode}`}
        size={size}
        fgColor={fgColor}
        bgColor={bgColor}
      />
      <div className="text-xs text-white mt-2 text-center leading-tight font-medium">
        <div>Scan to join</div>
        <div className="text-base font-bold leading-tight">
          {`Room ${roomCode}`}
        </div>
      </div>
    </div>
  )
}

export default QRCodeComponent
